<!--左侧菜单 Sag 2020-04-21-->
<template>
  <div class="its-help-menu">
    <div class="its-help-menu-pos">
      <div class="its-help-title">帮助中心</div>
      <div class="its-help-menu-container" v-loading="isLoading">
        <el-menu
          :unique-opened="uniqueOpen"
          :default-active="activeIndex"
          class=""
          @select="handleSelect"
          background-color="#FFFFFF"
          text-color="#333333"
          active-text-color="#white">
          <el-submenu v-for="(menu, i) in menus" :key="i" :index="menu.faqTopic.id+''">
            <template slot="title">
              <div class="its-menu-main-title" :title="menu.faqTopic.title">{{menu.faqTopic.title}}</div>
            </template>
            <el-menu-item  :index="faq.id + ''" v-for="(faq, j) in menu.faqQuestionList" :key="j">
                <div slot="title" class="its-menu-sub-title" :title="faq.title" @click="viewAnswer(faq)">{{faq.title}}</div>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    
  </div>
  
</template>
<script>
export default {
  name: 'Menu',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Array,
      default: function () {
        return []
      }
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      uniqueOpen: true,
      activeIndex: '0',
    }
  },
  watch: {
    menus: function () {
      const menuId = this.$route.query.id
      console.log(menuId)
      if (menuId) {
        // 定位到指定菜单
        const menuItem = this.getMenuById(menuId)
        this.viewAnswer(menuItem)
      } else {
        if (this.menus.length > 0) {
          let menu  = this.menus[0]
          this.activeIndex = menu.faqTopic.id + ''
          if (menu.faqQuestionList.length > 0) {
            this.activeIndex = menu.faqQuestionList[0].id + ''
            this.viewAnswer(menu.faqQuestionList[0])
          }
        }
      }
    }
  },
  methods: {
    getMenuById: function (id) {
      let menuItem = null
      this.menus.forEach(menu => {
        menu.faqQuestionList.forEach(ques => {
          if (ques.id === parseInt(id, 10)) {
            menuItem = ques
            this.activeIndex = id + ''
          }
        })
      })
      if (!menuItem) {
        if (this.menus.length > 0) {
          let menu  = this.menus[0]
          this.activeIndex = menu.faqTopic.id + ''
          if (menu.faqQuestionList.length > 0) {
            this.activeIndex = menu.faqQuestionList[0].id + ''
            // this.viewAnswer(menu.faqQuestionList[0])
          }
        }
      }
      return menuItem
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    viewAnswer: function (faq) {
      if (this.fatherAction) {
        this.fatherAction({type:'viewAnswer', faq: faq})
      }
    }
  }
}
</script>
<style scoped>
.its-help-menu {
  width: 250px;
  min-height: 100px;
  padding-bottom: 20px;
  /* background: #F5F5F5; */
}
.its-help-menu>>>.el-submenu .el-submenu__title:hover i {
  color: white;
}
.its-help-menu-pos{
  background: white;
  width: 250px;
  position: fixed;
  top: 90px;
}
.its-help-title {
  width: 100%;
  height: 60px;
  color: #ffffff;
  font-size: 16px;
  line-height: 60px;
  background: #5591fe;
  text-align: center;
}
.its-menu-main-title {
  font-size: 15px;
  color: #333333;
  overflow: hidden;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.its-menu-sub-title {
  font-size: 13px;
  color: #666666;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.its-help-menu>>>.el-submenu__title:hover,
.its-help-menu>>>.el-submenu .el-menu-item:hover,
.its-help-menu>>>.el-menu-item.is-active {
  background-color: #5591FE !important;
}
.its-help-menu>>>.el-submenu__title:hover .its-menu-main-title,
.its-help-menu>>>.el-submenu .el-menu-item:hover .its-menu-sub-title,
.its-help-menu>>>.el-menu-item.is-active .its-menu-sub-title {
  color: white !important;
}
.its-help-menu-container {
  min-height: 100px;
  margin-top: 5px;
  max-height: calc(100vh - 328px);
  overflow: auto;
}
</style>